export const CaretUp = (props: any) => <i {...props} className="fas fa-caret-up" />;
